export default function ProjectDetail() {
  return <div>Project Detail</div>;
}